<template>
    <div><h1>writing page</h1></div>
  
</template>

<script lang="ts">
export default {

}
</script>

<style>

</style>